import './UpgradeText.css';

import { useContext, useEffect, useState } from 'react';

import { Banner } from '@/components/Banner/Banner';
import { Context } from '@/components/Store';
import { languageStrings } from '@/l18n/de';
import { getBundle } from '@/lib/http';
import { setInnerHTML } from '@/lib/util';

const UpgradeText = () => {
  const [state] = useContext(Context);
  const [currentProduct, setCurrentProduct] = useState('');

  useEffect(() => {
    void (async () => {
      if (state?.upgrade?.isMovableSubscription && state?.upgrade?.moveFromBundleRef) {
        const { name } = await getBundle(state.upgrade.moveFromBundleRef);
        setCurrentProduct(name);
      }
    })().catch(() => {
      // Keep currentProduct as empty string on error
    });
  }, [state.upgrade.isMovableSubscription, state.upgrade.moveFromBundleRef]);

  return state?.upgrade?.isMovableSubscription ? (
    <>
      <Banner>
        <div dangerouslySetInnerHTML={setInnerHTML(languageStrings.upgrade.serviceCreditsInfo)}></div>
      </Banner>

      <Banner className="banner-okay">
        {currentProduct ? (
          <div dangerouslySetInnerHTML={setInnerHTML(languageStrings.upgrade.currentProductKnown(currentProduct, state.bundle?.name || ''))}></div>
        ) : (
          <div dangerouslySetInnerHTML={setInnerHTML(languageStrings.upgrade.currentProductUnknown(state.bundle?.name || ''))}></div>
        )}
      </Banner>
    </>
  ) : null;
};

export { UpgradeText };
